import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { experimentQuery } from '@/features/ml/experiments/experiment-api';
import { RunComparePage } from '@/features/ml/experiments/run-compare-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Comparaison de runs (acte 6). La sélection vit dans l'URL (`?runs=a,b` ; un emplacement libéré
 * s'écrit vide, `?runs=,b` — voir `compare-selection.ts`) : une comparaison se partage par un lien.
 */
export const Route = createFileRoute('/$tenant/projects/$projectId/experiments/$experimentId/compare')({
  validateSearch: (search: Record<string, unknown>): { runs?: string } =>
    typeof search['runs'] === 'string' ? { runs: search['runs'] } : {},
  component: CompareRoute,
});

function CompareRoute() {
  const { tenant, projectId, experimentId } = Route.useParams();
  const { runs } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  const experiment = useQuery(experimentQuery(tenant, projectId, experimentId));
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="experiments"
      crumbs={[
        { label: t('nav.items.experiments') },
        { label: experiment.data?.name ?? experimentId },
        { label: t('ml.compare.crumb') },
      ]}
    >
      <RunComparePage
        tenantId={tenant}
        projectId={projectId}
        experimentId={experimentId}
        runsParam={runs}
        onSelectionChange={(next) => void navigate({ search: { runs: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
